module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('div', {
    staticClass: "form-group col-sm-10 col-md-6"
  }, [_vm._m(0), _vm._v(" "), (_vm.error) ? _c('b-alert', {
    staticClass: "error-alert",
    attrs: {
      "show": "",
      "variant": "danger"
    }
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit()
      }
    }
  }, [_c('div', {
    staticClass: "form-label-group username-group"
  }, [_c('label', {
    ref: "username",
    staticClass: "label"
  }, [_c('span', {
    staticClass: "-text"
  }, [_vm._v("Benutzer")]), _vm._v(" "), _c('b-form-input', {
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.submit()
      }
    },
    model: {
      value: (_vm.credentials.username),
      callback: function($$v) {
        _vm.credentials.username = $$v
      },
      expression: "credentials.username"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-label-group password-group"
  }, [_c('label', {
    staticClass: "label"
  }, [_c('span', {
    staticClass: "-text"
  }, [_vm._v("Passwort")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "password"
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.submit()
      }
    },
    model: {
      value: (_vm.credentials.password),
      callback: function($$v) {
        _vm.credentials.password = $$v
      },
      expression: "credentials.password"
    }
  })], 1)]), _vm._v(" "), _c('b-button', {
    class: ['login-btn', {
      loading: _vm.loggingIn
    }],
    attrs: {
      "type": "submit",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.submit()
      }
    }
  }, [_c('span', [_vm._v("Login")]), _vm._v(" "), (_vm.loggingIn) ? _c('stretch', {
    staticClass: "loader",
    attrs: {
      "size": "25px",
      "background": "#fff"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _vm._m(1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('h2', {
    staticClass: "headline"
  }, [_vm._v("Login")]), _vm._v(" "), _c('p', {
    staticClass: "subline"
  }, [_vm._v("Light Scout Publisher")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "info text-muted"
  }, [_vm._v("\n\t\t\tDas Passwort vergessen / oder Login-Daten anfordern: "), _c('a', {
    attrs: {
      "href": "mailto:team@klickmeister.de"
    }
  }, [_vm._v("E-Mail an Klickmeister")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b1447d1c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/ErcoLogin.vue
// module id = 661
// module chunks = 0